// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__FdUFI","card":"classes_card__zlAkE","subcard":"classes_subcard__1BffB"};